// @flow
export { default } from './BannerHead';



// WEBPACK FOOTER //
// ./src/components/banner/BannerHead/index.js